// extracted by mini-css-extract-plugin
module.exports = {"qrbg":"#f6f6f6","qrcolor":"#00404f"};